import { render } from "./PersonCard.vue?vue&type=template&id=cccebf96&scoped=true"
import script from "./PersonCard.vue?vue&type=script&lang=js"
export * from "./PersonCard.vue?vue&type=script&lang=js"

import "./PersonCard.vue?vue&type=style&index=0&id=cccebf96&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cccebf96"]])

export default __exports__